import { Component, OnInit, Input } from '@angular/core';
import { BaseEditor } from '../baseEditor/base.editor'

@Component({
    selector: 'ixs-checkboxold',
    templateUrl: 'checkbox.component.html'
})
export class CheckboxComponent extends BaseEditor {
	constructor() {
		super();
	}
}


// WEBPACK FOOTER //
// ./src/app/components/checkbox/checkbox.component.ts